<template>
  <div class="koselugo-block">
    <div class="koselugo-block__tabs">
      <div class="koselugo-block__tab" @click="activeTab = 0" :class="{'koselugo-block__tab_active': activeTab == 0}">
        <svg
          width="49"
          height="48"
          viewBox="0 0 49 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_85_2210)">
            <mask
              id="mask0_85_2210"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="49"
              height="49"
            >
              <path
                d="M48.2714 -0.000488281H0.536621V47.0713H48.2714V-0.000488281Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_85_2210)">
              <mask
                id="mask1_85_2210"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="1"
                y="0"
                width="47"
                height="47"
              >
                <path
                  d="M47.6095 0.663086H1.20068V46.4089H47.6095V0.663086Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_85_2210)">
                <mask
                  id="mask2_85_2210"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="1"
                  y="0"
                  width="47"
                  height="47"
                >
                  <path
                    d="M47.6095 0.663574H1.20068V46.4094H47.6095V0.663574Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_85_2210)">
                  <mask
                    id="mask3_85_2210"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="1"
                    y="0"
                    width="47"
                    height="47"
                  >
                    <path
                      d="M47.6095 0.664062H1.20068V46.4099H47.6095V0.664062Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask3_85_2210)">
                    <path
                      d="M41.8448 9.05969C41.2102 8.57796 40.2996 8.69458 39.8109 9.32011L39.8096 9.32176C38.5091 10.9896 29.677 12.0999 24.4077 12.0999C19.1383 12.0999 10.3062 10.9896 9.00576 9.32176C8.51719 8.69544 7.60597 8.57803 6.97056 9.05969C6.33514 9.54128 6.21608 10.4395 6.70467 11.0658C8.15244 12.9487 9.88376 14.6022 11.8386 15.9692V25.919C11.8386 32.7615 17.466 38.3084 24.4077 38.3084C31.3493 38.3084 36.9767 32.7615 36.9767 25.919V15.9692C38.9316 14.6022 40.6629 12.9487 42.1106 11.0658C42.5993 10.4403 42.481 9.54267 41.8464 9.06094L41.8448 9.05969ZM24.4077 35.4493C19.0679 35.4493 14.7392 31.1824 14.7392 25.919V14.1632C17.4606 14.5787 20.205 14.8317 22.9574 14.9209V28.3015C22.9574 29.0911 23.6067 29.7311 24.4077 29.7311C25.2087 29.7311 25.8579 29.0911 25.8579 28.3015V14.9209C28.6103 14.8317 31.3547 14.5787 34.0761 14.1632V25.919C34.0761 31.1824 29.7474 35.4493 24.4077 35.4493Z"
                      stroke="#830051"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_85_2210">
              <rect
                width="47.7348"
                height="47.0718"
                fill="white"
                transform="translate(0.532715)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="koselugo-block__tab" @click="activeTab = 1" :class="{'koselugo-block__tab_active': activeTab == 1}">
        <svg
          width="49"
          height="47"
          viewBox="0 0 49 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_85_2234)">
            <mask
              id="mask0_85_2234"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="49"
              height="47"
            >
              <path d="M48.0676 0H0.332764V46.4088H48.0676V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_85_2234)">
              <mask
                id="mask1_85_2234"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="48"
                height="47"
              >
                <path
                  d="M47.4018 0.663574H0.99292V46.4094H47.4018V0.663574Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_85_2234)">
                <mask
                  id="mask2_85_2234"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="48"
                  height="47"
                >
                  <path
                    d="M47.3979 0.664062H0.989014V46.4099H47.3979V0.664062Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_85_2234)">
                  <mask
                    id="mask3_85_2234"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="48"
                    height="47"
                  >
                    <path
                      d="M47.3939 0.664551H0.985107V46.4104H47.3939V0.664551Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask3_85_2234)">
                    <path
                      d="M28.5065 9.93705C28.9319 9.09837 30.0148 9.24131 31.2233 9.7178C38.4167 12.82 43.5265 20.5872 43.5265 29.6935C43.5456 33.7354 42.4977 37.7128 40.4858 41.2348C40.3842 41.373 39.8379 42.0306 39.3545 42.0306C35.7047 42.0306 29.5265 38.3709 28.4147 35.0829C27.3027 31.7949 27.8007 25.2619 26.5632 23.3892C26.0405 22.5394 25.1788 21.9461 24.1895 21.7547C23.2003 21.9461 22.3385 22.5394 21.8159 23.3892C20.5783 25.2619 21.0763 31.7902 19.9644 35.0829C18.8525 38.3757 12.6744 42.0306 9.02449 42.0306C8.52657 42.0306 7.99482 41.373 7.89326 41.2348C5.88137 37.7128 4.83348 33.7354 4.85255 29.6935C4.85255 20.5872 9.96235 12.82 17.1557 9.7178C18.3884 9.24131 19.4472 9.1174 19.8774 9.95607C20.4333 11.0521 20.2545 14.7927 20.6412 15.4694C20.7978 15.8454 21.2044 16.0578 21.608 15.9745C22.2558 15.9126 22.2558 14.4831 22.2558 14.4831V4.95264H23.2227H26.1232V14.4831C26.1232 14.4831 26.1232 15.9126 26.7758 15.9555C27.1795 16.0387 27.586 15.8264 27.7427 15.4503C28.1294 14.7737 27.9506 11.033 28.5065 9.93705Z"
                      stroke="#830051"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_85_2234">
              <rect
                width="47.7348"
                height="46.4088"
                fill="white"
                transform="translate(0.332764)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="koselugo-block__tab" @click="activeTab = 2" :class="{'koselugo-block__tab_active': activeTab == 2}">
        <svg
          width="48"
          height="47"
          viewBox="0 0 48 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_85_2253)">
            <mask
              id="mask0_85_2253"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="48"
              height="48"
            >
              <path
                d="M47.8676 -0.000488281H0.132812V46.4084H47.8676V-0.000488281Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_85_2253)">
              <mask
                id="mask1_85_2253"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="48"
                height="47"
              >
                <path
                  d="M47.2018 0.662109H0.792969V46.408H47.2018V0.662109Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_85_2253)">
                <mask
                  id="mask2_85_2253"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="48"
                  height="47"
                >
                  <path
                    d="M47.2018 0.661621H0.792969V46.4075H47.2018V0.661621Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_85_2253)">
                  <mask
                    id="mask3_85_2253"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="48"
                    height="47"
                  >
                    <path
                      d="M47.2018 0.661133H0.792969V46.407H47.2018V0.661133Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask3_85_2253)">
                    <path
                      d="M10.7599 14.5802C11.1611 15.4327 11.4925 16.3155 11.751 17.2201C11.78 17.4012 11.8573 17.892 12.0023 18.5591C13.0732 17.7224 14.3686 17.2123 15.7296 17.0914L16.213 17.0295C16.2045 15.6878 16.3702 14.3506 16.706 13.0505C16.918 12.2888 17.2062 11.5497 17.5665 10.8443C17.4027 9.94007 16.5262 9.33802 15.609 9.49952C15.2093 9.56993 14.8487 9.78003 14.5935 10.0914C14.3711 10.3582 14.2406 10.5679 13.8007 12.3596C13.7556 12.5311 13.7169 12.7027 13.6847 12.8742C12.9789 11.4446 12.8145 11.2826 12.5583 11.073C11.8306 10.4951 10.7654 10.608 10.1792 11.3252C9.69442 11.9183 9.67874 12.7597 10.1412 13.3698C10.1895 13.4555 10.3635 13.7605 10.7599 14.5802Z"
                      stroke="#830051"
                    />
                    <path
                      d="M37.179 25.3972C35.9656 21.5279 33.8772 18.6831 33.0698 17.892C32.5951 17.4654 32.0729 17.093 31.5133 16.7817C31.3489 16.9104 31.1845 17.0486 31.0298 17.1915C30.5464 17.6204 30.0194 18.8165 29.6665 20.3128C29.5656 20.7436 29.1773 21.0494 28.7287 21.0514C28.6548 21.0584 28.5803 21.0584 28.5063 21.0514C27.9864 20.9314 27.6636 20.4187 27.7853 19.9063L27.786 19.9029C28.1051 18.5306 28.7094 16.7007 29.7197 15.7906C30.9368 14.6849 32.374 13.8411 33.94 13.3127C34.4238 13.1521 34.8234 12.8095 35.0519 12.3596C35.5443 11.4255 35.1752 10.2748 34.2276 9.78946C33.7545 9.54714 33.2009 9.50809 32.6976 9.68159C30.6428 10.374 28.755 11.4772 27.1527 12.9219C25.1514 14.6803 24.2522 17.7777 23.8993 19.4646C23.7912 19.9804 23.2793 20.3121 22.756 20.2055C22.2327 20.0989 21.8962 19.5944 22.0043 19.0786C22.4877 16.7341 23.5706 13.5128 25.8716 11.4972C26.8258 10.6507 27.8658 9.90336 28.9752 9.26703C28.6751 8.90531 28.3271 8.58482 27.9407 8.31399C27.9987 8.08526 28.0616 7.83751 28.1341 7.61832C28.4242 6.66525 28.5498 6.34122 28.5837 6.26021C28.9083 5.68529 28.6985 4.95989 28.1153 4.63996C27.6211 4.36888 27.0023 4.47186 26.6258 4.88783C26.4663 5.06415 26.3503 5.19281 25.8185 6.9321C25.7605 7.12271 25.7073 7.31329 25.659 7.50389H25.5526V7.33238C25.5526 6.33168 25.5865 5.9886 25.5962 5.90282C25.7449 5.26144 25.3381 4.62259 24.6874 4.47591C24.1333 4.35098 23.5657 4.62363 23.324 5.13086C23.2225 5.34529 23.1452 5.49778 23.1355 7.31328C23.1355 7.52776 23.1355 7.74217 23.1355 7.9471L22.9325 8.03289C22.7294 7.07982 22.6811 6.76056 22.6714 6.67479C22.6598 6.01695 22.1094 5.49292 21.442 5.50435C20.906 5.5135 20.4401 5.86975 20.2978 6.37934C20.2446 6.61284 20.2059 6.77485 20.5878 8.55227C20.6588 8.86997 20.7409 9.18761 20.8344 9.50531C19.7534 10.6346 18.9757 12.0121 18.572 13.5128C18.0547 15.3808 18.1417 16.9486 18.0886 18.7545C18.0886 18.8451 17.929 18.7974 17.929 18.7974C17.2813 18.8082 16.6352 18.864 15.9953 18.9642C14.2743 19.2453 13.409 19.7219 12.4422 20.8274C11.4753 21.9329 10.2474 23.7675 10.1072 27.1031C9.99132 29.2891 10.6266 31.4499 11.9104 33.236C12.7632 34.4304 13.6984 35.5657 14.7094 36.6335C15.3948 37.2533 16.113 37.837 16.8607 38.3824C19.5271 40.2766 22.5517 41.6247 25.7556 42.3471C28.8834 42.9475 33.3019 42.509 34.8344 41.4797C36.3668 40.4505 37.6962 37.3293 37.9766 35.204C38.4251 31.9165 38.1531 28.5723 37.179 25.3972Z"
                      stroke="#830051"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_85_2253">
              <rect
                width="47.7348"
                height="46.4088"
                fill="white"
                transform="translate(0.132812)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="koselugo-block__tab" @click="activeTab = 3" :class="{'koselugo-block__tab_active': activeTab == 3}">
        <svg
          width="49"
          height="48"
          viewBox="0 0 49 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_85_2273)">
            <mask
              id="mask0_85_2273"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="49"
              height="48"
            >
              <path d="M48.6677 0H0.932861V47.0718H48.6677V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_85_2273)">
              <mask
                id="mask1_85_2273"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="1"
                y="0"
                width="48"
                height="47"
              >
                <path
                  d="M48.0019 0.662598H1.59302V46.4085H48.0019V0.662598Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_85_2273)">
                <mask
                  id="mask2_85_2273"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="1"
                  y="0"
                  width="48"
                  height="47"
                >
                  <path
                    d="M48.0019 0.662598H1.59302V46.4085H48.0019V0.662598Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_85_2273)">
                  <mask
                    id="mask3_85_2273"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="1"
                    y="0"
                    width="48"
                    height="47"
                  >
                    <path
                      d="M48.0019 0.662598H1.59302V46.4085H48.0019V0.662598Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask3_85_2273)">
                    <path
                      d="M43.1667 26.919C44.5687 24.9177 44.472 22.2015 42.925 20.2954C43.1184 19.7236 43.2151 19.1518 43.2151 18.5799C43.2151 15.8638 41.233 13.5765 38.5742 13.0523C37.7524 10.7174 35.577 9.19249 33.0632 9.19249C32.6281 9.19249 32.1447 9.24016 31.7096 9.3355C30.6944 8.14418 29.1958 7.42942 27.6488 7.28643C26.0535 7.19113 24.5066 7.7153 23.3464 8.76368C21.8477 7.76297 19.9624 7.47702 18.2704 8.00118C16.5301 8.5254 15.1765 9.81199 14.548 11.5275C14.4513 11.5275 14.3063 11.5275 14.2096 11.5275C11.019 11.5275 8.45691 14.0054 8.40856 17.1503C8.40856 17.2457 8.40856 17.341 8.40856 17.4363C6.47485 18.4847 5.36297 20.5337 5.508 22.7256C5.70137 25.7277 8.40856 27.9674 11.5025 27.9674H18.9955C22.1861 27.9674 24.7966 30.4929 24.845 33.638V39.7374H28.664V35.4488C28.664 35.2581 28.664 35.0199 28.664 34.8293C28.664 33.0661 28.6157 30.8265 29.8726 29.3969C30.6461 28.5868 31.5162 27.8721 32.4348 27.2526C33.1599 26.8237 33.7883 26.2996 34.3201 25.6801C34.5618 25.2989 34.8035 24.9177 34.9486 24.5364C33.9333 24.1552 32.8698 24.0123 31.8063 24.1552C31.2745 24.2029 30.7911 23.8693 30.6944 23.3451C30.6461 22.821 30.9844 22.3444 31.5162 22.2492C32.8214 22.0585 34.1267 22.2015 35.3836 22.678C35.3836 22.535 35.3836 22.4398 35.4319 22.2968C35.4803 21.5343 35.3836 20.772 35.1419 20.0571C34.4651 18.3417 32.7731 17.5792 31.1778 16.9598C30.8877 16.8645 30.5977 16.7691 30.211 16.6739L29.9209 16.5786H29.8726C29.4858 16.6262 29.1475 16.7215 28.7607 16.8645L28.3256 16.9598L27.8422 17.0551C27.0203 18.0081 26.5853 19.247 26.682 20.5337C26.7787 21.8203 27.4071 22.9639 28.374 23.774C28.7607 24.1076 28.7607 24.6794 28.4706 25.1083C28.1806 25.4418 27.6005 25.4895 27.2138 25.2035C26.6337 24.7271 26.1502 24.1076 25.7635 23.4405H25.6668C24.3132 23.2022 22.7662 22.9639 21.5093 22.1538C21.0742 21.8679 20.9776 21.2961 21.2676 20.8672C21.5577 20.4384 22.1378 20.2954 22.5729 20.5813C23.298 21.0102 24.1198 21.2961 24.99 21.3914C24.8933 21.1531 24.845 20.9149 24.7966 20.629C24.7 19.5806 24.8933 18.4847 25.3284 17.5316C24.6516 17.6269 24.0231 17.6746 23.3464 17.6746C22.7662 17.6746 22.1861 17.6269 21.6061 17.5316C20.5425 18.8182 19.0439 19.7713 17.4002 20.1525C15.2249 21.2485 13.1944 22.6304 13.1944 24.9653C13.1944 25.4895 12.7593 25.9184 12.2276 25.9184C11.6958 25.9184 11.2607 25.4895 11.2607 24.9653C11.3091 23.1545 12.1309 21.4867 13.5328 20.3431C12.3726 20.2001 11.3091 19.7236 10.5356 18.8659C10.1972 18.437 10.2939 17.8652 10.6806 17.5316C11.0674 17.198 11.6958 17.2457 12.0342 17.6269C12.421 18.1034 13.5328 18.5323 15.1281 18.4847C16.7235 18.4847 18.3187 17.9128 19.5273 16.8645C18.1254 16.2926 16.9651 15.2443 16.24 13.91C15.95 13.4335 16.1433 12.8617 16.5784 12.6234C17.0618 12.3376 17.6419 12.5282 17.8837 12.957C19.3339 15.5302 22.3795 16.245 27.1654 15.149C26.2952 14.4342 25.6668 13.2906 25.7151 11.4798C25.7151 10.9556 26.1986 10.5267 26.7303 10.5744C27.2621 10.5744 27.6972 11.0509 27.6488 11.5751C27.5522 13.7195 28.7607 14.1483 30.6944 14.7201C30.9844 14.8155 31.2745 14.8631 31.5646 14.9584C32.0963 13.7671 33.1599 12.8617 34.4651 12.5282C34.9968 12.3852 35.5286 12.7188 35.6737 13.2429C35.8187 13.7671 35.4803 14.2912 34.9486 14.4342C34.2717 14.6248 33.74 15.0537 33.4016 15.6732C33.4016 15.7208 33.4016 15.7208 33.4016 15.7685C34.9002 16.4833 36.2054 17.5316 36.8823 19.2947C37.0273 19.6759 37.1239 20.0571 37.1723 20.4384C37.3656 20.2954 37.5107 20.1048 37.6074 19.8665C37.9458 19.1518 38.1875 18.437 38.2841 17.6269C38.3325 17.2934 38.5742 17.0074 38.9126 16.8645C39.251 16.7215 39.6377 16.8168 39.8794 17.0551C40.1695 17.2934 40.2662 17.6269 40.1695 18.0081C40.0245 18.9612 39.7344 19.9142 39.251 20.772C38.7676 21.582 38.0425 22.2492 37.1723 22.7256C37.0756 23.917 36.6888 25.1083 36.1088 26.1566C36.7372 26.8713 37.414 27.4908 38.2358 27.9674C38.5259 28.158 38.7192 28.4915 38.7192 28.8251C38.7192 29.1587 38.5259 29.4923 38.1875 29.6352C37.849 29.7781 37.5107 29.7781 37.2206 29.5875C36.3988 29.0634 35.6253 28.3962 34.9486 27.6814C34.4651 28.0627 33.9333 28.4439 33.4499 28.7774C32.6281 29.3016 31.9029 29.8735 31.2745 30.5882C30.5011 31.4936 30.5493 33.2567 30.5493 34.7816C30.5493 35.0199 30.5493 35.2105 30.5493 35.4488V39.7374H34.4167C34.4167 33.5427 37.414 33.2091 37.8007 33.1138C39.0576 32.7803 42.3933 31.0648 43.1184 27.5385C43.2151 27.3479 43.1667 27.1096 43.1667 26.919ZM43.1667 26.919C43.1184 26.919 43.1184 26.919 43.1667 26.919Z"
                      stroke="#830051"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_85_2273">
              <rect
                width="47.7348"
                height="47.0718"
                fill="white"
                transform="translate(0.932617)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="koselugo-block__tab" @click="activeTab = 4" :class="{'koselugo-block__tab_active': activeTab == 4}">
        <svg
          width="49"
          height="47"
          viewBox="0 0 49 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_85_2292)">
            <mask
              id="mask0_85_2292"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="49"
              height="48"
            >
              <path
                d="M48.4677 -0.00012207H0.73291V46.4087H48.4677V-0.00012207Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_85_2292)">
              <mask
                id="mask1_85_2292"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="1"
                y="0"
                width="47"
                height="47"
              >
                <path
                  d="M47.8019 0.661987H1.39307V46.4078H47.8019V0.661987Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_85_2292)">
                <mask
                  id="mask2_85_2292"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="1"
                  y="0"
                  width="47"
                  height="47"
                >
                  <path
                    d="M47.798 0.661499H1.38916V46.4074H47.798V0.661499Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_85_2292)">
                  <mask
                    id="mask3_85_2292"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="1"
                    y="0"
                    width="47"
                    height="47"
                  >
                    <path
                      d="M47.7941 0.661011H1.38525V46.4069H47.7941V0.661011Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask3_85_2292)">
                    <path
                      d="M15.733 25.5769L17.1833 20.6666M23.6805 25.515C23.5685 25.5595 23.4483 25.5806 23.3276 25.5769C22.3946 25.5769 21.1668 24.6858 20.7993 23.9043M27.3352 32.9058V26.8731M21.5341 26.8731V32.9249M28.0493 23.9043C27.6819 24.6858 26.4505 25.5769 25.5175 25.5769C25.3968 25.5806 25.2766 25.5595 25.1646 25.515M23.3276 19.5537H21.5341M23.3276 17.6476H21.5341M23.3276 15.7416H21.5341M23.3276 13.8355H19.7993M30.6273 15.1506L31.4201 18.5626M31.7993 20.4999L33.1653 25.8438M18.4149 15.1506L17.57 18.7913M27.3352 35.4999V42.9999M21.5341 35.4999V42.9999M24.4346 12.3738V22.7655M25.5175 13.8355H28.8893M25.5175 15.7416H27.1045M25.5175 17.6476H27.1045M25.5175 19.5537H27.1045M34.9733 25.3672L32.2661 14.0261C32.171 13.6319 31.9707 13.27 31.686 12.9778C30.4869 12.0203 29.1065 11.3077 27.6252 10.881C26.5754 10.6603 25.5076 10.5327 24.4346 10.4999C23.3543 10.5182 22.2814 10.6785 21.2441 10.9764C19.747 11.3634 18.3585 12.0803 17.1833 13.073C16.8986 13.3653 16.6983 13.7272 16.6031 14.1214L13.896 25.4626C13.8543 25.6193 13.822 25.7785 13.7993 25.9391C13.7993 26.9917 14.6651 27.8452 15.733 27.8452C16.597 27.8169 17.3416 27.2374 17.57 26.4156L19.6004 18.1242V44.8093H23.4678V27.6546H25.4015V44.8093H29.2689V18.0289L31.2992 26.3203C31.5276 27.1422 32.2723 27.7217 33.1363 27.7498C34.2042 27.7498 35.07 26.8965 35.07 25.8438C35.0472 25.6832 35.015 25.5241 34.9733 25.3672Z"
                      stroke="#830051"
                      stroke-linecap="round"
                    />
                    <path
                      d="M21.2078 5.47857C21.1396 3.56678 22.6525 1.96054 24.5917 1.88562C26.5309 1.96054 28.0438 3.56678 27.9757 5.47857C27.9853 6.22571 27.7286 6.9525 27.2505 7.53239V7.9803C27.2563 8.47787 26.914 8.91398 26.4239 9.03338V9.7148C26.4239 9.978 26.2075 10.1914 25.9405 10.1914H23.243C22.976 10.1914 22.7595 9.978 22.7595 9.7148V9.03338C22.2695 8.91398 21.9271 8.47787 21.9329 7.9803V7.53239C21.4548 6.9525 21.1982 6.22571 21.2078 5.47857Z"
                      stroke="#830051"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_85_2292">
              <rect
                width="47.7348"
                height="46.4088"
                fill="white"
                transform="translate(0.73291)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <div class="koselugo-block__body">
      <div class="koselugo-block__content" v-show="activeTab === 0">
        <ul style="color: #830051">
          <li>
            <span style="color: #3c4242"
              >ПН языка, глотки и гортани могут затруднять интубацию.</span
            >
          </li>
          <li>
            <span style="color: #3c4242"
              >Следует обращать внимание на эпизоды дисфагии, дизартрии,
              осиплости голоса в анамнезе.</span
            >
          </li>
          <li>
            <span style="color: #3c4242"
              >Непрямая ларингоскопия поможет оценить состояние глотки и
              гортани.</span
            >
          </li>
        </ul>
      </div>
      <div class="koselugo-block__content" v-show="activeTab === 1">
        <ul style="color: #830051">
          <li>
            <span style="color: #3c4242"
              >Внутрилегочные ПН могут вызывать кашель и одышку.</span
            >
          </li>
          <li>
            <span style="color: #3c4242"
              >ПН средостения, а также ПН другой локализации (параспинальные,
              забрюшинные), распространяющиеся на средостение, способны
              приводить к серьезной обструкции дыхательных путей.</span
            >
          </li>
          <li>
            <span style="color: #3c4242"
              >Предоперационные оценка легочной функции, КТ и МРТ помогут учесть
              возможные риски.</span
            >
          </li>
        </ul>
      </div>
      <div class="koselugo-block__content" v-show="activeTab === 2">
        <ul style="color: #830051">
          <li>
            <span style="color: #3c4242"
              >У пациентов с НФ1 часто имеется эссенциальная гипертензия, но
              необходимо исключить другие причины повышенного АД
              (феохромоцитома, стеноз почечной артерии).</span
            >
          </li>
          <li>
            <span style="color: #3c4242"
              >Другие возможные сопутствующие проявления НФ1: гипертрофическая
              кардиомиопатия, недостаточность правого желудочка, обструкция
              верхней полой вены (при опухолях средостения), васкулопатии.</span
            >
          </li>
        </ul>
      </div>
      <div class="koselugo-block__content" v-show="activeTab === 3">
        <ul style="color: #830051">
          <li>
            <span style="color: #3c4242"
              >Возможная сопутствующая патология включает цереброваскулярную
              болезнь, эпилепсию.</span
            >
          </li>
          <li>
            <span style="color: #3c4242"
              >Следует учитывать риски, связанные со спинальной анестезией при
              наличии параспинальных ПН (предоперационная визуализация).</span
            >
          </li>
        </ul>
      </div>
      <div class="koselugo-block__content" v-show="activeTab === 4">
        <ul style="color: #830051">
          <li>
            <span style="color: #3c4242"
              >Деформации позвоночника могут также затруднить спинальную
              анестезию.</span
            >
          </li>
          <li>
            <span style="color: #3c4242"
              >Сколиоз/кифоз может привести к нарушению функции легких.</span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "koselugoBlock",
  data: () => ({
    activeTab: 0
  })
};
</script>

<style lang="scss" scoped>
.koselugo-block {
  &__tabs {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    height: 96px;
    column-gap: 24px;

    @media screen and (max-width: 767px) {
      column-gap: 8px;
    }
  }

  &__tab {
    padding: 16px;
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D2D2D2;
    border-radius: 8px;
    cursor: pointer;
    transition: .3s;
    
    & > svg {
      width: 100%;
    }

    &_active {
      background-color: #F4EFF4;
      border-color: #F4EFF4;
      height: 100%;
      border-radius: 8px 8px 0 0;
    }
  }

  &__body {
    margin-top: -4px;
    padding: 24px;
    background-color: #F4EFF4;
    border-radius: 8px;
  }
}
</style>